// extracted by css-extract-rspack-plugin
export default {"toggle":"xqhpN"};